import BasePropertyView from 'BasePropertyView.js';
import {Model} from 'backbone';
import RestService from 'RestService.js';
import SelectItemModalView from 'common-views/SelectItemModalView.js';
import selectFieldModal from 'common-views/SelectFieldModalView';
import Template from 'behaviors/properties/main/cancel-notify.ejs';
import constants from 'Constants.js';
import Spinner from 'spin/spin';
import userService from 'UserService';
//=====================================================================
//
// An instance of this view represents an auto-summary.
//
// Casey Justus, April 15, 2016 - Tax Day
//
//=====================================================================

class MainCancellationView extends BasePropertyView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.Spinner = new Spinner();

        this.events = {
            'change input[type=radio]'      : 'updateAttributes',
            'change input[type=text]'       : 'updateTextAttributes',
            'blur input[type=text]'         : 'lostFocus',
            'focus input[type=text]'        : 'getFocus',
            'click #notifyUser, #notifyGroup, #notifyPosition, #notifyEmailField' : 'openModal'
        };

        if (!this.model.get('cancelNotifyUser')) {
            this.model.set('cancelNotifyUser', "", {silent: true});
        }

        if (!this.model.get('cancelNotifyUserGroup')) {
            this.model.set('cancelNotifyUserGroup', "", {silent: true});
        }

        if (!this.model.get('cancelNotifyPosition')) {
            this.model.set('cancelNotifyPosition', "", {silent: true});
        }

        if (!this.model.get('cancelNotifyFixedEmail')) {
            this.model.set('cancelNotifyFixedEmail', "", {silent: true});
        }

        if (!this.model.get('fixedEmailWriteable')) {
            this.model.set('fixedEmailWriteable', "readonly", {silent: true});
        }

        if (!this.model.get('cancelNotifyEnteredEmail')) {
            this.model.set('cancelNotifyEnteredEmail', "", {silent: true});
        }

        this.setDisplayValue();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    openModal(ev) {
        switch (ev.target.id) {
            case 'notifyUser':
                this.displayUsersModal();
                break;
            case 'notifyGroup':
                this.displayUserGroupsModal();
                break;
            case 'notifyPosition':
                this.displayPositionModal();
                break;
            case 'notifyEmailField':
                this.displayValueFieldModal()
                break;
        }
    }

    displayUsersModal(){
        this.Spinner.spin($(constants.CONTENT_ID).get(0));
        setTimeout(() => {
            RestService.browseAllUsers().then((userData)=> {
                //console.log('User Data',userData);
                let items = userService.mapUsers(userData, constants.USER_TYPE_USER);

                const alertView = new SelectItemModalView({model: new Model({items:items}), spinner: this.Spinner, mappedUsers: true });

                alertView.render().then(selectedItemInModal => {
                    console.log('Selected Item',selectedItemInModal);
                    if(selectedItemInModal) {

                        this.model.set('cancelNotifyUser',selectedItemInModal.label, {silent: true} );
                        this.model.set('cancelNotificationName', selectedItemInModal.label, {silent: true});
                        this.model.set('cancelNotificationId', selectedItemInModal.id, {silent: true});
                        this.model.set('cancelNotificationType', '3', {silent: true});
                        this.render();
                    }
                });
            });
        }, 10);
    }

    displayUserGroupsModal(){
        RestService.browseAllUsers().then((userGroupsResponse)=> {
          
            let items = userService.mapUsers(userGroupsResponse, constants.USER_TYPE_GROUP);
            const alertView = new SelectItemModalView({model: new Model({items:items}), mappedUsers: true });

            alertView.render().then(selectedItemInModal => {
                console.log('Selected Item',selectedItemInModal);
                if(selectedItemInModal) {
                    this.model.set('cancelNotifyUserGroup',selectedItemInModal.label, {silent: true});
                    this.model.set('cancelNotificationName', selectedItemInModal.label, {silent: true});
                    this.model.set('cancelNotificationId', selectedItemInModal.id, {silent: true});
                    this.model.set('cancelNotificationType', '7', {silent: true});
                    this.render();
                }
            });
        });
    }


    displayPositionModal(){
        RestService.browseAllUsers().then((positionsResponse)=> {
            let items = userService.mapUsers(positionsResponse, constants.USER_TYPE_POSITION);
            const alertView = new SelectItemModalView({model: new Model({items:items}), mappedUsers: true });

            alertView.render().then(selectedItemInModal => {
                console.log('Selected Item',selectedItemInModal);
                if(selectedItemInModal) {
                    this.model.set('cancelNotifyPosition',selectedItemInModal.label, {silent: true});
                    this.model.set('cancelNotificationName', selectedItemInModal.label, {silent: true});
                    this.model.set('cancelNotificationId', selectedItemInModal.id, {silent: true});
                    this.model.set('cancelNotificationType', '4', {silent: true});
                    this.render();
                }
            });
        });
    }

    displayValueFieldModal() {
        var sfModel = new Model();
        sfModel.set("dataSelectedItemId", this.model.get('cancelNotificationId'), {silent:true});

        var sfModal = new selectFieldModal({model: sfModel,  mode: 'insertField'});
        sfModal.render().then((selectedField)=>{
            this.model.set('cancelNotifyEnteredEmail', selectedField.name, {silent: true});
            this.model.set('cancelNotificationName', selectedField.name, {silent: true});
            this.model.set('cancelNotificationId', selectedField.id, {silent: true});
            this.model.set('cancelNotificationType', '6', {silent: true});
            this.render();
        }).catch(err => console.log(err));
    }


    updateTextAttributes(ev) {
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set(propName, propVal, {silent: true});
        this.model.set('cancelNotificationName', propVal, {silent: true});
        this.model.set('cancelNotificationId', '', {silent: true});
        this.render();
    }

    updateAttributes(ev) {
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.clearTextValues();

        this.model.set(propName, propVal, {silent: true});
        this.model.set('fixedEmailWriteable', 'readonly', {silent: true});
        this.model.set('cancelNotificationName', '', {silent: true});
        this.model.set('cancelNotificationId', '', {silent: true});


        if (propName === "cancelNotifyType"){

            switch (propVal) {
                case "all":
                    this.model.set('cancelNotificationType', '2', {silent: true});
                    break;
                case "fixedEmail":
                    this.model.set('fixedEmailWriteable', '', {silent: true});
                    this.model.set('cancelNotificationType', '5', {silent: true});
                    break;
                case "user":
                    this.model.set('cancelNotificationType', '3', {silent: true});
                    break;
                case "userGroup":
                    this.model.set('cancelNotificationType', '7', {silent: true});
                    break;
                case "position":
                    this.model.set('cancelNotificationType', '4', {silent: true});
                    break;
                case "enteredEmail":
                    this.model.set('cancelNotificationType', '6', {silent: true});
                    break;
            }
            this.render();
        }
    }

    clearTextValues() {
        this.model.set('cancelNotifyUser','', {silent: true} );
        this.model.set('cancelNotifyPosition','', {silent: true});
        this.model.set('cancelNotifyUserGroup','', {silent: true});
        this.model.set('cancelNotifyFixedEmail','', {silent: true});
        this.model.set('cancelNotifyEnteredEmail','', {silent: true});
        $('input[name=cancelNotifyUser]').val('');
        $('input[name=cancelNotifyUserGroup]').val('');
        $('input[name=cancelNotifyPosition]').val('');
        $('input[name=cancelNotifyFixedEmail]').val('');
        $('input[name=cancelNotifyEnteredEmail]').val('');
    }

    setDisplayValue() {
        let widgetText = '';
        switch (this.model.get('cancelNotificationType')) {
            case "2":
                this.model.set('cancelNotifyType','all', {silent: true});
                widgetText = 'All';
                break;
            case "3":
                this.model.set('cancelNotifyUser',this.model.get('cancelNotificationName'), {silent: true} );
                this.model.set('cancelNotifyType','user', {silent: true});
                widgetText = this.model.get('cancelNotifyUser');
                $('#notifyUser').removeAttr('disabled');
                break;
            case "4":
                this.model.set('cancelNotifyPosition',this.model.get('cancelNotificationName'), {silent: true} );
                this.model.set('cancelNotifyType','position', {silent: true});
                widgetText = this.model.get('cancelNotifyPosition');
                $('#notifyPosition').removeAttr('disabled');
                break;
            case "5":
                this.model.set('cancelNotifyFixedEmail',this.model.get('cancelNotificationName'), {silent: true} );
                this.model.set('cancelNotifyType','fixedEmail', {silent: true});
                widgetText = this.model.get('cancelNotifyFixedEmail');
                break;
            case "6":
                this.model.set('cancelNotifyEnteredEmail',this.model.get('cancelNotificationName'), {silent: true} );
                this.model.set('cancelNotifyType','enteredEmail', {silent: true});
                widgetText = this.model.get('cancelNotifyEnteredEmail');
                $('#notifyEmailField').removeAttr('disabled');
                break;
            case "7":
                this.model.set('cancelNotifyUserGroup',this.model.get('cancelNotificationName'), {silent: true} );
                this.model.set('cancelNotifyType','userGroup', {silent: true});
                widgetText = this.model.get('cancelNotifyUserGroup');
                $('#notifyGroup').removeAttr('disabled');
                break;
        }
        $("input:radio[value='"+this.model.get('cancelNotifyType')+"']").attr('checked', true);
        if (this.model.get('autosummary')){
            this.model.set('widgetText', widgetText);
        }
    }

    render() {

        if (this.model.get('cancelNotifyType') === 'fixedEmail'){
            this.model.set('fixedEmailWriteable', '', {silent: true});
        }

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.setDisplayValue();

        this.delegateEvents();
        return this;
    }

}

export default MainCancellationView;
